import React, { useEffect, useState } from 'react';
import { Collapse, Icon, Modal, Row, Table } from 'antd';

import { Button, FormatText, FormInput, FormSubmitButton, MasterDetailForm, Widget } from '@digital/ui';
import { ClausulaPesquisa, Clausula, getAllClausulaComItemAprovado } from '@app/api/minuta/Clausula';
import { Item } from '@app/api/minuta/ItemClausula';

const { Panel } = Collapse;

interface Props {
  visible: boolean;
  tipoClasulaId?: string;
  clausulaMinutaId: string;
  onSelected: (id: string) => void;
  onCancel: () => void;
}

const ModalAddItemClausula: React.FC<Props> = ({ visible, tipoClasulaId, clausulaMinutaId, onSelected, onCancel }) => {
  const [itensAprovados, setItensAprovados] = useState<Clausula[]>([]);

  const initItens = async (termo: string) => {
    var data = await getAllClausulaComItemAprovado({ termo, tipoClasulaId, clausulaMinutaId } as ClausulaPesquisa);

    if (data) {
      setItensAprovados(data);
    }
  };

  useEffect(() => {
    if (visible) {
      initItens('');
    }
  }, [visible, tipoClasulaId]);

  const columnsTable = [
    {
      title: 'Item',
      dataIndex: 'descricao',
      width: '95%',
    },
    {
      title: 'Selecionar',
      isDummyField: true,
      width: '5%',
      render: (index: number, record: Item, rowkey: number) => {
        return [
          <Button
            key="select"
            icon="editing-circled"
            onClick={() => {
              onSelected(record.id);
            }}
          />,
        ];
      },
    },
  ];

  return (
    <Modal visible={visible} title="Adicionar item" onCancel={onCancel}>
      {itensAprovados && itensAprovados.length > 0 ? (
        <>
          {itensAprovados.map(clausula => {
            return (
              <Collapse
                key={`${clausula.id}`}
                defaultActiveKey={[clausula.id]}
                bordered={false}
                expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel key={`${clausula.id}`} header={`${clausula.descricao}`}>
                  <Widget>
                    <Table rowKey={'id'} columns={columnsTable} dataSource={clausula.itens} />
                  </Widget>
                </Panel>
              </Collapse>
            );
          })}
        </>
      ) : (
        <></>
      )}
    </Modal>
  );
};

export default ModalAddItemClausula;
